import lazyLoading from './lazyLoading'

export default {
  name: 'Users Manager',
  // system: 'users_manager',
  auth: 'accountManager',
  path: '/usersManager',
  meta: {
    auth: true,
    system: 'users_mananger',
    icon: 'fa-users',
    label: 'Users Manager',
  },
  component: lazyLoading('usersManager', true)
}
